export default "/react/logoTrendFlow-ff4f11c7.png";